import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
export function ContactPage() {
  const [formState, setFormState] = useState({
    status: 'idle' // idle, submitting, success
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState({
      status: 'submitting'
    });
    // Simulate API call
    setTimeout(() => {
      setFormState({
        status: 'success'
      });
    }, 1500);
  };
  return <div className="w-full bg-warm-white" data-id="element-267">
      {/* Header */}
      <div className="bg-primary-900 text-warm-white py-20 lg:py-28" data-id="element-268">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-269">
          <h1 className="text-4xl lg:text-6xl font-heading mb-6" data-id="element-270">
            Get in Touch
          </h1>
          <p className="text-xl text-primary-100 font-body max-w-2xl mx-auto" data-id="element-271">
            Questions about our programs, workshops, or certification? We'd love
            to hear from you.
          </p>
        </div>
      </div>

      <AnimatedSection className="py-20 lg:py-24" data-id="element-272">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-274">
            {/* Contact Info Sidebar */}
            <div className="lg:col-span-1 space-y-8" data-id="element-275">
              <div data-id="element-276">
                <h2 className="text-2xl font-heading text-primary-900 mb-6" data-id="element-277">
                  Contact Information
                </h2>
                <p className="font-body text-warm-gray-600 mb-8" data-id="element-278">
                  Fill out the form to ask about any of our programs, request a
                  workshop quote, or get help choosing the right learning path.
                </p>
              </div>

              <div className="space-y-6" data-id="element-279">
                <div className="flex items-start gap-4" data-id="element-280">
                  <div className="bg-primary-50 p-3 rounded-full text-primary-800 shrink-0" data-id="element-281">
                    <Mail className="w-6 h-6" data-id="element-282" />
                  </div>
                  <div data-id="element-283">
                    <h3 className="font-heading text-lg text-primary-900" data-id="element-284">
                      Email
                    </h3>
                    <a href="mailto:hello@pawverse.com" className="font-body text-warm-gray-600 hover:text-accent-600 transition-colors" data-id="element-285">
                      hello@pawverse.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-286">
                  <div className="bg-primary-50 p-3 rounded-full text-primary-800 shrink-0" data-id="element-287">
                    <Phone className="w-6 h-6" data-id="element-288" />
                  </div>
                  <div data-id="element-289">
                    <h3 className="font-heading text-lg text-primary-900" data-id="element-290">
                      Phone
                    </h3>
                    <a href="tel:+14155550198" className="font-body text-warm-gray-600 hover:text-accent-600 transition-colors" data-id="element-291">
                      (415) 555-0198
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-292">
                  <div className="bg-primary-50 p-3 rounded-full text-primary-800 shrink-0" data-id="element-293">
                    <MapPin className="w-6 h-6" data-id="element-294" />
                  </div>
                  <div data-id="element-295">
                    <h3 className="font-heading text-lg text-primary-900" data-id="element-296">
                      Service Area
                    </h3>
                    <p className="font-body text-warm-gray-600" data-id="element-297">
                      Based in San Francisco.
                      <br data-id="element-298" />
                      Serving the entire Bay Area.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-299">
              <div className="bg-white rounded-3xl shadow-warm-lg border border-warm-gray-100 p-8 lg:p-12" data-id="element-300">
                {formState.status === 'success' ? <div className="text-center py-12" data-id="element-301">
                    <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-302">
                      <Send className="w-8 h-8" data-id="element-303" />
                    </div>
                    <h3 className="text-2xl font-heading text-primary-900 mb-4" data-id="element-304">
                      Message Sent!
                    </h3>
                    <p className="font-body text-warm-gray-600 mb-8" data-id="element-305">
                      Thank you for reaching out. We'll get back to you within
                      24-48 hours.
                    </p>
                    <button onClick={() => setFormState({
                  status: 'idle'
                })} className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-sm font-medium rounded-full text-primary-800 bg-primary-50 hover:bg-primary-100 transition-all" data-id="element-306">
                      Send Another Message
                    </button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-307">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-308">
                      <div data-id="element-309">
                        <label htmlFor="name" className="block text-sm font-medium text-primary-900 font-body mb-2" data-id="element-310">
                          Full Name
                        </label>
                        <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-warm-gray-200 focus:ring-2 focus:ring-accent-500 focus:border-transparent outline-none transition-all font-body" placeholder="Jane Doe" data-id="element-311" />
                      </div>
                      <div data-id="element-312">
                        <label htmlFor="email" className="block text-sm font-medium text-primary-900 font-body mb-2" data-id="element-313">
                          Email Address
                        </label>
                        <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border border-warm-gray-200 focus:ring-2 focus:ring-accent-500 focus:border-transparent outline-none transition-all font-body" placeholder="jane@example.com" data-id="element-314" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-315">
                      <div data-id="element-316">
                        <label htmlFor="phone" className="block text-sm font-medium text-primary-900 font-body mb-2" data-id="element-317">
                          Phone Number
                        </label>
                        <input type="tel" id="phone" className="w-full px-4 py-3 rounded-xl border border-warm-gray-200 focus:ring-2 focus:ring-accent-500 focus:border-transparent outline-none transition-all font-body" placeholder="(415) 555-0000" data-id="element-318" />
                      </div>
                      <div data-id="element-319">
                        <label htmlFor="inquiry" className="block text-sm font-medium text-primary-900 font-body mb-2" data-id="element-320">
                          Inquiry Type
                        </label>
                        <select id="inquiry" className="w-full px-4 py-3 rounded-xl border border-warm-gray-200 focus:ring-2 focus:ring-accent-500 focus:border-transparent outline-none transition-all font-body bg-white" data-id="element-321">
                          <option data-id="element-322">Free Resources Question</option>
                          <option data-id="element-323">Video Course Inquiry</option>
                          <option data-id="element-324">Workshop / On-Site Training</option>
                          <option data-id="element-325">Certification Program</option>
                          <option data-id="element-326">General Question</option>
                        </select>
                      </div>
                    </div>

                    <div data-id="element-327">
                      <label htmlFor="message" className="block text-sm font-medium text-primary-900 font-body mb-2" data-id="element-328">
                        Message
                      </label>
                      <textarea id="message" rows={5} required className="w-full px-4 py-3 rounded-xl border border-warm-gray-200 focus:ring-2 focus:ring-accent-500 focus:border-transparent outline-none transition-all font-body resize-none" placeholder="How can we help you?" data-id="element-329"></textarea>
                    </div>

                    <button type="submit" disabled={formState.status === 'submitting'} className="w-full sm:w-auto inline-flex justify-center items-center px-8 py-4 border border-transparent text-base font-bold rounded-full text-warm-white bg-primary-800 hover:bg-primary-700 shadow-warm transition-all disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-330">
                      {formState.status === 'submitting' ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </AnimatedSection>
    </div>;
}